import { toast, toastSuccess, toastError, toastInfo, toastWarning } from './toast';

/**
 * Thin hook wrapper over the toast bus for ergonomic use inside components.
 * (The bus is global, so this is just a convenience surface.)
 */
export const useToast = () => ({
  notify: toast,
  success: toastSuccess,
  error: toastError,
  info: toastInfo,
  warning: toastWarning,
});
